import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import GoogleReviewsCarousel from "@/components/GoogleReviewsCarousel";

export default function Reviews() {
  const { settings } = useOutletContext();
  const [google, setGoogle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/google-reviews")
      .then(r => setGoogle(r.data))
      .catch(() => setGoogle(null))
      .finally(() => setLoading(false));
  }, []);

  const writeReviewUrl = google?.write_review_uri || settings?.google_business_url || google?.google_maps_uri;
  const hasLive = google?.enabled && Array.isArray(google?.reviews) && google.reviews.length > 0;

  return (
    <>
      <PageHeader eyebrow="Parent stories" title="Reviews" />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12">

        {/* Google-branded CTA bar — always shown when we have any writable link */}
        {writeReviewUrl && (
          <div className="mb-10 card-surface p-6 flex flex-wrap items-center gap-4" data-testid="reviews-google-cta">
            <img
              src="https://www.gstatic.com/marketing-cms/assets/images/d5/dc/cfe9ce8b4425b410b49b7f2dd3f3/g.webp=s96-fcrop64=1,00000000ffffffff-rw"
              alt="Google"
              className="h-5 w-5 opacity-80"
            />
            <div className="text-sm text-zinc-300 max-w-xl">
              Loved your experience with 2RightFeet? Share it on Google — it takes 30 seconds and means the world to our teachers.
            </div>
            <a
              href={writeReviewUrl}
              target="_blank"
              rel="noreferrer"
              className="btn-red !py-2 !px-4 !text-xs ml-auto"
              data-testid="reviews-google-cta-link"
            >
              Leave a Google review →
            </a>
          </div>
        )}

        {/* Live Google reviews */}
        {hasLive && (
          <section data-testid="google-reviews-section">
            <GoogleReviewsCarousel data={google} testPrefix="google-review" reviewUrl={writeReviewUrl} />
          </section>
        )}

        {/* Nothing to show */}
        {!loading && !hasLive && !writeReviewUrl && (
          <div className="text-zinc-500 text-center py-20" data-testid="reviews-empty">
            Reviews will appear here once our Google Business listing is connected.
          </div>
        )}
      </div>
    </>
  );
}
